import { render, staticRenderFns } from "./AdvSwitch.vue?vue&type=template&id=18484913"
import script from "./AdvSwitch.vue?vue&type=script&lang=js"
export * from "./AdvSwitch.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/indsol-advisor/indsol-advisor/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('18484913')) {
      api.createRecord('18484913', component.options)
    } else {
      api.reload('18484913', component.options)
    }
    module.hot.accept("./AdvSwitch.vue?vue&type=template&id=18484913", function () {
      api.rerender('18484913', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/common/AdvSwitch.vue"
export default component.exports